import { WeaponDef } from '../types';

// IMPORTANT: fireIntervalMs values here must match backend/src/weapons.ts
// exactly, since the server re-derives max-possible-shots from that file,
// not from this one. This file only controls client-side feel/rendering.
export const WEAPONS: WeaponDef[] = [
  {
    id: 'glock',
    name: 'Glock',
    category: 'pistol',
    fireIntervalMs: 220,
    damage: 34,
    magazineSize: 15,
    reloadMs: 900,
    spreadDeg: 1.2,
    pelletsPerShot: 1,
    basePoints: 50,
    color: 0xffd166,
  },
  {
    id: 'deagle',
    name: 'Desert Eagle',
    category: 'pistol',
    fireIntervalMs: 500,
    damage: 90,
    magazineSize: 7,
    reloadMs: 1400,
    spreadDeg: 1.8,
    pelletsPerShot: 1,
    basePoints: 90,
    color: 0xff9e7d,
  },
  {
    id: 'mp5',
    name: 'MP5',
    category: 'smg',
    fireIntervalMs: 100,
    damage: 22,
    magazineSize: 30,
    reloadMs: 1600,
    spreadDeg: 2.6,
    pelletsPerShot: 1,
    basePoints: 30,
    color: 0x4ecdc4,
  },
  {
    id: 'ak47',
    name: 'AK-47',
    category: 'rifle',
    fireIntervalMs: 150,
    damage: 45,
    magazineSize: 30,
    reloadMs: 1800,
    spreadDeg: 2.0,
    pelletsPerShot: 1,
    basePoints: 55,
    color: 0xff6b35,
  },
  {
    id: 'awp',
    name: 'AWP',
    category: 'sniper',
    fireIntervalMs: 1500,
    damage: 200,
    magazineSize: 5,
    reloadMs: 2200,
    spreadDeg: 0.2,
    pelletsPerShot: 1,
    basePoints: 150,
    color: 0xff3355,
  },
  {
    id: 'spas12',
    name: 'SPAS-12',
    category: 'shotgun',
    fireIntervalMs: 800,
    damage: 18,
    magazineSize: 8,
    reloadMs: 2000,
    spreadDeg: 8,
    pelletsPerShot: 6,
    basePoints: 15,
    color: 0xd9a066,
  },
];

export function getWeapon(id: string): WeaponDef {
  const w = WEAPONS.find((w) => w.id === id);
  if (!w) throw new Error(`Unknown weapon: ${id}`);
  return w;
}
